import state from './moduleClassifiedState'
import actions from './moduleClassifiedActions'
import getters from './moduleClassifiedGetters'
import mutations from './moduleClassifiedMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

